import React, { PropsWithChildren } from 'react';
import { useAuth } from '@neotech-solutions-org/neofusion-fe-shared';
import { Navigate } from 'react-router';

const AuthProtectedRoute: React.FC<PropsWithChildren> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to='/' replace />;
  }

  return <>{children}</>;
};

export default AuthProtectedRoute;
